export const ACTION_TYPE = {
  PREVIEW: 'preview',
  SUBMIT: 'submit'
}
